import httpRequest from '../../utils/httpRequest';
import API from '@/api';

const SERVER_NAME = 'logistics/etcDevice';
/**
 * 设备列表
 */
export function queryPage(data) {
    return httpRequest({
        url: '/queryPage',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}
export function newQueryPage(data) {
    return httpRequest({
        url: '/queryDevicePage',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}

export function exportEtcEquipment(data) {
    return httpRequest({
        url: '/issueActive/export',
        serverName: 'logistics',
        method: 'post',
        data,
        notReg: true,
        responseType: 'blob'
    });
}

export function exportObuEquipment(data) {
    return httpRequest({
        url: '/exportObuList',
        serverName: SERVER_NAME,
        method: 'post',
        data,
        notReg: true,
        responseType: 'blob'
    });
}

/**
 * 激活
 * * @param {Object} data
 */
export function add(data) {
    return httpRequest(
        {
            url: '/activationEtcDevice',
            serverName: SERVER_NAME,
            method: 'post',
            data,
        },
        {
            resolveError: true,
        }
    );
}

/**
 * 绑定调度单
 * * @param {Object} params
 */
export function bindDispatchNo(params) {
    return httpRequest({
        url: '/bindDispatchNo',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}
/**
 * 绑定调度订单
 * * @param {Object} params
 */
export function bindDispatchOrderNo(params) {
    return httpRequest({
        url: '/bindDispatchOrder',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}
/**
 * 获取详情
 */
export function get(params) {
    return httpRequest({
        url: '/get',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}

/**
 * 修改设备承运商
 */
export function updateDeviceCarrier(params) {
    return httpRequest({
        url: '/updateDeviceCarrier',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}

/**
 * 注销ETC设备
 * * @param {Object} params
 */
export function cancelEtcDevice(params) {
    return httpRequest(
        {
            url: '/cancelEtcDevice',
            serverName: SERVER_NAME,
            method: 'get',
            params,
        },
        {
            resolveError: true,
        }
    );
}

/**
 * 批量恢复ETC设备
 * * @param {Object} data
 */
export function recoveryEtcDevice(data) {
    return httpRequest(
        {
            url: '/recoveryEtcDevice',
            serverName: SERVER_NAME,
            method: 'POST',
            data,
        },
        {
            resolveError: true,
        }
    );
}

/**
 * 请求授权
 * * @param {Object} data
 */
export function obuAuthorize(data) {
    return httpRequest(
        {
            url: '/obuAuthorize',
            serverName: SERVER_NAME,
            method: 'POST',
            data,
        },
        {
            resolveError: true,
        }
    );
}

/**
 * 清分/结算ETC
 * * @param {Object} data
 */
export function clearingEtcDevice(params) {
    return httpRequest(
        {
            url: '/clearingEtcDevice',
            serverName: SERVER_NAME,
            method: 'get',
            params,
        },
        {
            resolveError: true,
        }
    );
}
/**
 * 设备表工作台
 * * @param {Object} data
 */
export function deviceWorkBench(params) {
    return httpRequest(
        {
            url: '/deviceWorkBench',
            serverName: SERVER_NAME,
            method: 'get',
            params,
        },
        {
            resolveError: true,
        }
    );
}

/**
 * 解绑
 * * @param {Object} data
 */
export function unBind(params) {
    return httpRequest({
        url: '/unBindDispatchNo',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}
/**
 * 解绑调度订单
 * * @param {Object} data
 */
export function unBindOrder(params) {
    return httpRequest({
        url: '/unBindDispatchOrder',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}
// 切换设备持有方
export function checkCarrier(params) {
    return httpRequest(
        {
            url: '/updateDeviceCarrier',
            serverName: SERVER_NAME,
            method: 'get',
            params,
        },
        {
            resolveError: true,
        }
    );
}

// 新增etc设备
export function bindDeviceAndCard(params) {
    return httpRequest({
        url: '/bindDeviceAndCard',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}
// 删除etc设备
export function remove(params) {
    return httpRequest({
        url: '/unBindDeviceAndCard',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}

/**
 * 设备出厂管理
 */
export function initContractQueryPage(data) {
    return httpRequest({
        url: '/initContract/queryPage',
        serverName: 'logistics',
        method: 'post',
        data,
    });
}

/**
 * 删除设备出厂管理
 */
export function deleteInitContract(params) {
    return httpRequest({
        url: '/initContract/delete',
        serverName: 'logistics',
        method: 'get',
        params,
    });
}


/**
 * 设备出厂明细查询
 * @param {Object} params
 * @return {Promise<*>|*}
 */
export function getInitContract(params) {
    return httpRequest({
        url: '/initContract/get',
        serverName: 'logistics',
        method: 'get',
        params,
    });
}

/**
 * 新增设备出厂
 * @param {Object} data
 */
export function saveInitContract(data) {
    return httpRequest({
        url: '/initContract/add',
        serverName: 'logistics',
        method: 'post',
        data,
    });
}

/**
 * 修改设备出厂
 * @param {Object} data
 */
export function editInitContract(data) {
    return httpRequest({
        url: '/initContract/edit',
        serverName: 'logistics',
        method: 'post',
        data,
    });
}

